import React, { useRef, FC, HTMLAttributes, useEffect } from "react";

import { useResizeObserver } from "../../utils";
import { IconButton } from "../IconButton";
import { ArrowLeftIcon } from "../Icons";
import { MenuHeader } from "../Menu";

interface SubmenuProps {
  title: string;
  onBack: () => void;
  onHeightChange?: (height: number) => void;
  indexPage?: boolean;
}

export const Submenu: FC<SubmenuProps & HTMLAttributes<HTMLDivElement>> = ({
  onBack,
  onHeightChange,
  style,
  children,
  title,
  indexPage,
}) => {
  const ref = useRef(null);
  const dimensions = useResizeObserver(ref);
  const height = dimensions?.height;

  useEffect(() => {
    if (height && height > 0 && !indexPage) {
      onHeightChange?.(height);
    }
  }, [height, onHeightChange, indexPage]);

  return (
    <div style={style} ref={ref}>
      <MenuHeader
        title={title}
        leftElement={
          <IconButton onClick={onBack} variant="text gray" size="small">
            <ArrowLeftIcon />
          </IconButton>
        }
      />
      {children}
    </div>
  );
};
